import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../BaseUrl";

export const getPmsIssueItems = createAsyncThunk(
    "/user/getPmsViewIssueItems",
    async ({ formData }) => {
        try {
            const myurl = `${V_URL}/user/pro-one-issue`;
            const response = await axios({
                method: "post",
                url: myurl,
                data: formData,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("PAY_USER_TOKEN"),
                },
            });
            const data = response.data;
            if (data.success === true) {
                return data;
            } else {
                throw new Error(data);
            }
        } catch (error) {
            console.log(error, "error");
            toast.error(error.response.data.message);
            return error;
        }
    }
);

const getPmsViewIssueItemsSlice = createSlice({
    name: "getPmsViewIssueItems",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getPmsIssueItems.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getPmsIssueItems.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getPmsIssueItems.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default getPmsViewIssueItemsSlice.reducer;
